<div #filterContainer
  class="common-dropdown-container">
  <span-tooltip
    class="common-table-cell__title-text-label"
    [text]="filterBySearch.label">
  </span-tooltip>
  <div>
    <button class="common-button__filter-order-button"
      (click)="toggleFilter($event)">
      <i class="lf-icon-filter-1 common-icon__md"
        ngClass="{{item.value ? 'common-button__filter-order-button--active lf-icon-filter-applied' : 'lf-icon-filter-1'}}">
      </i>
    </button>
    <p-overlayPanel
      [id]="'filterSearch-' + filterBySearch.id"
      styleClass="common-dropdown-overlay__container">
      <ng-template pTemplate="content">
        <div class="common-search__container-tonal">
          <div class="common-search__container-input-text">
            <input
              type="search"
              class="common-search__input-text"
              pAutoFocus
              [autofocus]="true"
              [(ngModel)]="item.value"
              placeholder="{{'common.search-item' | afTranslate}}"
              (keyup)="filterSearch()">
          </div>
          <div class="common-search__block-button-search">
            @if(item.value){
              <button class="common-button__icon-xs-noborder"
                (click)="resetFilter()">
                <i class="lf-icon-close-thick common-icon__sm"></i>
              </button>
            }
            <div class="h-[22px]"
              ngClass="{{item.value?'common-divider__vertical-main-1000':'common-divider__vertical-grey-400'}}">
            </div>
            <i class="lf-icon-search common-icon__md"
              ngClass="{{!item.value ? 'common-search__icon-search-disabled' : 'common-search__icon-search-enabled'}}">
            </i>
          </div>
        </div>
      </ng-template>
    </p-overlayPanel>
  </div>
  @if (item?.filterOrder) {
    <button class="common-button__filter-order-button"
      [ngClass]="{ 'common-button__filter-order-button--active': filterOrder === item?.filterOrder }"
      (click)="orderColumn()">
      <i class="common-icon__md"
        [ngClass]="filterOrder === item?.filterOrder && !order ? 'lf-icon-arrow-up' : 'lf-icon-arrow-down'">
      </i>
    </button>
  }
</div>
